<template>
  <img
    src="/images/utamed-logo-horizontal-blanco.svg"
    alt="UTAMED"
    width="106"
    height="32"
    data-testid="admin-ui-svg-full-logo"
  />
</template>
